var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBaby = function SvgBaby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M7.5 10.036h.008M12.5 10.036h.008M8.333 13.37c.417.25 1 .416 1.667.416s1.25-.166 1.667-.416"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M15.833 5.286a7.5 7.5 0 0 1 1.5 3.25 1.666 1.666 0 0 1 0 3 7.5 7.5 0 0 1-14.666 0 1.667 1.667 0 0 1 0-3 7.5 7.5 0 0 1 7.333-6c1.667 0 2.917.917 2.917 2.084 0 1.166-.75 2.083-1.667 2.083-.667 0-1.25-.333-1.25-.833"
  })));
};
export default SvgBaby;